<div class="layout">
  <muni-admin-sidebar />

  <div class="layout__main">
    <muni-admin-header />

    <main class="layout__content">
      <router-outlet />
    </main>
  </div>
</div>
